import CaspianXxApiQueryItem from "../Domain/CaspianXxApiQueryItem.js";
import dateTimeHelper from "../Helpers/datetimeHelper.js";
import serviceHelper from "../Helpers/serviceHelper.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import CaspianXxApiQuerySearchParams from "../Contents/RoverImport/CaspianXxApiQueryAdmin/CaspianXxApiQuerySearchParams";

class CaspianXXApiQueryService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, CaspianXxApiQuerySearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/CaspianXExtraApiQuery/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map(item => new CaspianXxApiQueryItem(item));
    }

    return mappedItems;
  }

  static Edit(queryItem) {
    queryItem = serviceHelper.ConvertAllPropertyToString(queryItem);
    queryItem.StartDate = dateTimeHelper.toYYYYsMMsDD(queryItem.StartDate);
    queryItem.EndDate = dateTimeHelper.toYYYYsMMsDD(queryItem.EndDate);
    let queryItemJSON = JSON.stringify(queryItem);

    return AuthService.getInstance().CallBackendFunctionPut("/api/CaspianXExtraApiQuery/Edit", queryItemJSON);
  }
}

export default CaspianXXApiQueryService;
